module.exports = __webpack_public_path__ + "img/bread.e9a0607c.svg";